const ModalSearch = function () {

    const boxSearch = () => {
        $("#modal-search").fadeToggle(200);
    }

    return {
        init : () => {
            $(document).on("click", ".searchBtn", boxSearch);
        }
    }

}();

export default ModalSearch;